import {Component, OnDestroy, OnInit} from '@angular/core';
import {SectionComponent} from '../../elements/section/section.component';
import {FeedbackComponent} from '../../elements/feedback/feedback.component';
import {HeaderService} from '../../../services/header-service';
import {ScrollService} from '../../../services/scroll-service';
import {ThemeService} from '../../../services/theme.service';
import {MenuService} from '../../../services/menu-services';

interface onChanges {
}

@Component({
  selector: 'app-feedback-page',
  imports: [
    FeedbackComponent
  ],
  templateUrl: './feedback-page.component.html',
  styleUrl: './feedback-page.component.scss'
})
export class FeedbackPageComponent implements OnInit, OnDestroy, onChanges {

  constructor(protected interfaceService: HeaderService,
              private scroll: ScrollService,
              public themeService: ThemeService,
              protected menuService: MenuService) {}

  isMobile: boolean = false;


  ngOnInit() {
    this.interfaceService.setPageInterface('header-container-white');
    if (window.innerWidth < 571) {
      this.isMobile = true;
    }
  }

  ngOnDestroy() {
  }

  get mobileStyle() {
    return '';
    if (!this.isMobile) {
      return 'var(--background-color);'
    }
    if (this.menuService.getInputFocused()) {
      return "white"
    }
    return "black"
  }

}
